export default __webpack_public_path__ + "static/81491-a463f83a72c58dd85c2228f2a031b60d.jpg";